module.exports = __webpack_public_path__ + "img/mdi_alert-outline.142394a2.svg";